import React from 'react';
import HvSvg from 'src/components/HvSvg';
import {
  SelectionUnavailableContainer,
  SelectionUnavailableIcon,
  SelectionUnavailableContent,
} from './styled';

const PROPERTY_REQUIRED_MESSAGES = {
  productId: 'Brand',
  colorId: 'Product',
};

const SelectionUnavailable = ({ attributeName }) => (
  <SelectionUnavailableContainer>
    <SelectionUnavailableIcon>
      <HvSvg src={require('src/assets/images/ic-noedit.svg')} />
    </SelectionUnavailableIcon>
    <SelectionUnavailableContent>
      Select {PROPERTY_REQUIRED_MESSAGES[attributeName]} first
    </SelectionUnavailableContent>
  </SelectionUnavailableContainer>
);

export default SelectionUnavailable;
